<template>
  <div class="home_page">
    <Header @open="openFormModal" />

    <Categories
      :search="search"
      :categories-list="categoriesList"
      :courses-list="coursesList"
      @change="changeSwiper"
      @open="openCourseInfo"
      :ie="true"
      :is-loading="isLoading"
    />

    <Info />

    <Offer @open="openFormModal" />

    <Feed :feeds-list="feedsList" />

    <Partners :ie="true" />

    <b-modal :active.sync="isFormShow" has-modal-card scroll="keep">
      <CreateForm @submit="submitForm" @close-modal="closeFormModal" :form="newForm" />
    </b-modal>
  </div>
</template>

<script>
import CreateForm from '@/components/modal/CreateForm'
import Header from '@/components/home/Header'
import Info from '@/components/home/Info'
import Offer from '@/components/home/Offer'
import Feed from '@/components/home/Feed'
import Partners from '@/components/home/Partners'
import { toastInfo } from '@/lib/toastCfg'

export default {
  name: 'homeIE',
  components: {
    CreateForm,
    Header,
    Info,
    Offer,
    Feed,
    Partners
  },
  data() {
    return {
      isLoading: false,
      isFormShow: false,
      newForm: this.defaultForm(),
      activeTab: 0,
      search: {
        category: 0
      },
      feedsList: [
        'ЦРпН выручает. Удобно проходить курсы с телефона. Если что-то забыл, то информация всегда под рукой, можно зайти и посмотреть. Еще удобно готовиться к тестам.',
        'Я поддерживаю идею о том, что учиться надо всегда и везде. Нравится, что не нужно никуда ехать, чтобы прослушать лекцию или пройти очередной тест. Открыл ноутбук, вошел в свой личный кабинет, прошел тест. Спасибо за возможность заниматься из дома.',
        'Видеоматериалы, фото и презентации в онлайн-курсе отлично заменили скучные лекции в колледже. Удобно, что есть система напоминаний и оповещений. Радуют нестандартные тесты. Желаю развивать это направление и дальше.'
      ]
    }
  },
  computed: {
    coursesList() {
      return this.categoriesList[this.search.category].courses
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    }
  },
  methods: {
    loadCourses(categoryIindex) {
      this.isLoading = true
      const currentCategory = this.categoriesList[categoryIindex]
      let newCourses = currentCategory.courses
      if (newCourses.length > 0) {
        this.isLoading = false
        return
      }
      this.$axios2
        .get('courses/list?category_id=' + currentCategory.id)
        .then((resp) => {
          this.$store.commit('setCategoryCoursesList', { list: resp.data, index: categoryIindex })
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    defaultForm() {
      return {
        name: '',
        phone: '',
        comment: '',
        region: ''
      }
    },
    openFormModal() {
      this.isFormShow = true
      this.newForm = this.defaultForm()
    },
    closeFormModal() {
      this.isFormShow = false
    },
    submitForm() {
      this.$axios
        .post('submit-application', this.newForm)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.closeFormModal()
        })
        .catch(this.$errorToast)
    },
    openCourseInfo(courseId) {
      this.$router.push('/course-info/' + courseId)
    },
    changeSwiper() {
      this.loadCourses(this.search.category)
    }
  }
}
</script>
